module.exports = __webpack_public_path__ + "static/media/secure.d7b27228.svg";